import React, {Component} from 'react'
import {Modal, Button, Table} from 'antd'
import {CloseCircleOutlined, DeleteOutlined, DownloadOutlined, QuestionCircleFilled} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'

const {confirm} = Modal
let downloadId = null
let currentPageNumber = 1

@inject('reportManagementStore','auditLogsStore')
@observer
class FormModal extends Component {
  formRef = React.createRef()
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    tableData: [],
    tableLoading: false,
    generateButtonLoading: false,
    timer: null,
  }

  handleOk = () => {
    const {handleCancel, reportManagementStore, reportId} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      reportManagementStore.saveReport({...fieldsValue, id: reportId}).then(res => {
        if (res.code === 0) {
          handleCancel('modalVisible')
        }
      })
    })
  }

  handleSearch = (pageNumber, pageSize) => {
    this.setState({tableLoading: true})
    const {reportManagementStore, reportId} = this.props
    const {page, size} = this.state

    let params = {
      pageNo: pageNumber ? pageNumber : page,
      pageSize: pageSize ? pageSize : size,
      reportId: reportId
    }
    reportManagementStore.getExportPageList(params).then(res => {
      if (res?.code === 0) {
        const queueData = res.data?.list.filter(item => item.id === downloadId)[0]
        if (queueData && queueData.status === 2) {
          this.handleDownload(queueData.filePath)
          downloadId = null
        }
        this.setState({
          tableData: res.data?.list,
          page: pageNumber ? pageNumber : page, // 当前页
          size: pageSize ? pageSize : size, // 每页显示条数
          total: res.data?.total // 总条数
        })
        currentPageNumber = pageNumber
      }
      this.setState({tableLoading: false})
    }).catch(() => {
      this.setState({tableLoading: false})
    })
  }

  generateReport = () => {
    this.setState({generateButtonLoading: true})
    const {reportManagementStore, generateParams,reportName,auditLogsStore} = this.props
    const logBody =  generateParams.conditions
    .filter(condition => condition.value && condition.value.trim() !== "" && condition.value.trim() !== '[]') // 剔除空值和仅包含空格的 value
    .map(condition => {
      // 处理 value 的格式
      let value = condition.value;
      if (value.startsWith("[") && value.endsWith("]")) {
        value = value.slice(1, -1); // 去掉方括号
      }
      return `${condition.name}：${value}`;
    });

    const params = {
      logUrl: "/api/v1/report/detail/export/generate",
      logOperationType: "导出数据",
      logType:reportName + ':生成数据报表导出',
      logBody:String(logBody),
      
    }
    
    auditLogsStore.insertAuditLog(params)


    reportManagementStore.generateReport(generateParams).then(res => {
      if (res.code === 0) {
        this.handleSearch(1, 10)
        downloadId = Number(res.data)
      }
      this.setState({generateButtonLoading: false})
    }).catch(() => {
      this.setState({generateButtonLoading: false})
    })
  }

  handleDownload = filePath => {
    window.open(filePath, '_self')
  }

  handleDelete = id => {
    const {t, reportManagementStore} = this.props
    let _this = this

    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        reportManagementStore.deleteGenerateReport(id).then(() => {
          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
  }

  handleCancel = id => {
    const {t, reportManagementStore} = this.props
    let _this = this

    confirm({
      title: t(`general.cancelData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToCancel`),
      okText: t(`general.ok`),
      cancelText: t(`general.cancel`),
      onOk() {
        reportManagementStore.cancelGenerateReport(id).then(() => {
          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
  }

  closeModal = () => {
    const {handleCancel} = this.props

    handleCancel('modalVisible')
  }

  componentDidMount() {
    this.handleSearch(1, 10)
    this.setState({
      timer: setInterval(() => {
        this.handleSearch(currentPageNumber, 10)
      }, 1000 * 3)
    })
  }

  componentWillUnmount() {
    const {timer} = this.state

    downloadId = null
    if (timer) {
      clearInterval(timer)
    }
  }

  render() {
    const {t, modalVisible, handleCancel, reportName} = this.props
    const {page, size, total, tableData, tableLoading, generateButtonLoading} = this.state
    const pagination = getPaginationConfig(page, size, total, this.handleSearch)
    const statusList = tableData.map(item => item.status)

    return (
      <Modal
        title={`${reportName} - ${t(`general.export`)}`}
        width="70%"
        closable={true}
        onCancel={this.closeModal}
        visible={modalVisible}
        maskClosable={false}
        destroyOnClose={true}
        centered
        footer={[
          <Button key="Cancel" onClick={() => { handleCancel('modalVisible') }}>{t(`general.close`)}</Button>,
        ]}
      >
        <div style={{textAlign: 'right'}}>
          <Button
            key="unlock"
            style={{marginRight: '10px'}}
            onClick={this.generateReport}
            loading={generateButtonLoading}
            disabled={statusList.find(item => item === 0) > -1}
          >
            {t(`reportManagement.generateReports`)}
          </Button>
        </div>

        <Table
          className="searchResult"
          dataSource={tableData}
          rowKey="id"
          pagination={pagination}
          rowClassName={this.getRowClassName}
          loading={tableLoading}
        >
          <Table.Column title={t(`reportManagement.exportCreateUser`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
          <Table.Column title={t(`reportManagement.exportTime`)} dataIndex="exportTime" key="exportTime" ellipsis={true}/>
          <Table.Column
            title={t(`reportManagement.taskStatus`)}
            dataIndex="status"
            key="status"
            ellipsis={true}
            render={text => text === 0 ? '排队中' : text === 1 ? '进行中' : text === 2 ? '已完成' : text === 3 ? '已失败' : text === 4 ? '已取消' : null}
          />
          <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, record) => {
            return (
              <>
                {
                  record.status === 2 &&
                  <Button type="link" onClick={() => this.handleDownload(record.filePath)} icon={<DownloadOutlined/>} title={t(`general.download`)}/>
                }
                {
                  (record.status === 2 || record.status === 3 || record.status === 4) &&
                  <Button type="link" onClick={() => this.handleDelete(record.id)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
                }
                {
                  record.status === 0 &&
                  <Button type="link" onClick={() => this.handleCancel(record.id)} icon={<CloseCircleOutlined/>} title={t(`general.cancel`)}/>
                }
              </>
            )
          }}/>
        </Table>
      </Modal>
    )
  }
}

export default withTranslation()(FormModal)
